<div class="login-page">
  <div *ngIf="showTFAComponent" class="login-box-container">
    <two-factor-auth (onTFAComponentClose)="onTFAComponentClose($event)"></two-factor-auth>
  </div>
  <div *ngIf="!showTFAComponent">
    <div *ngIf="showComponent === loginComponentScreen['Login']" class="login-box-container">
      <login #loginComponent [withNewEmail]="withNewEmail"></login>
    </div>
    <div *ngIf="showComponent === loginComponentScreen['Register']" class="login-box-container">
      <register
        #registerComponent
        (triggerTFAComponent)="triggerTFAComponent()"
        [continueRegister]="continueRegister"
      ></register>
    </div>
    <div *ngIf="showComponent === loginComponentScreen['Reset']" class="login-box-container">
      <reset-password #resetPasswordComponent></reset-password>
    </div>
  </div>
</div>
